enum ProductType {
  'ABC Outbound' = 1,
  'ABC Inbound' = 2,
  'SDS Outbound' = 3,
  'SDS Inbound' = 4,
  'ABC Outbound A2A' = 5,
  'ABC Inbound A2A' = 6,
  'SDS Outbound A2A' = 7,
  'SDS Inbound A2A' = 8
}
export default ProductType;



// WEBPACK FOOTER //
// ./src/enum/product-type.enum.ts